/** @flow */

export const defaultFontStack = `-apple-system, system-ui, BlinkMacSystemFont, 
    "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", 
    "Fira Sans", "Droid Sans", "Helvetica Neue", 
    sans-serif`;

export const defaultFontSize = 17;

export const defaults = {
  fontFamily:
    `-apple-system, system-ui, BlinkMacSystemFont, ` +
    `"Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", ` +
    `"Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif`,
  fontSize: "17px",
  lineHeight: 1.2,
  fontStyle: "inherit",
  fontWeight: "inherit",
  letterSpacing: "inherit"
};
